import linkAdsMixin from '@/components/Mixins/linkAds'
import mixins from 'vue-typed-mixins'

/**
 * linkAdsList
 *
 * 展示多个物品时的 mixin，提供 PageView 和 click 上报的简单封装
 *
 * 输入为 prop，展示时使用 showArr
 * 当需要部分展示时，可使用 isSpread；在用户点击【展示全部/收起】时可调用 spread 方法，并会自动上报
 */
export default <T>() => mixins(linkAdsMixin).extend({
  props: {
    arr: Array as () => T[],
    PVIformat: String,
    clickIformat: String
  },

  data() {
    return {
      isSpread: false,
      showArr: [] as T[],
      firstOpen: true
    }
  },

  watch: {
    arr: {
      handler(val) {
        if (val && val.length > 0) {
          const arr = []
          if (this.arr) {
            this.arr.forEach(item => {
              arr.push(item)
            })
          }
          this.showArr = arr
        } else {
          this.showArr = []
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    reportAll(arr: ReportItem[]) {
      let indexs = ''
      let groupIds = ''
      arr.forEach((item, index) => {
        indexs += `&${index}`
        groupIds += item.groupId ? `&${item.groupId}` : ''
      })
      indexs && (indexs = encodeURIComponent(indexs.slice(1)))
      groupIds && (groupIds = encodeURIComponent(groupIds.slice(1)))
      this.reportAdsPV(indexs, { groupId: groupIds }, this.PVIformat)
    },

    /**
       * 上报前三个已经展示的业务
       */
    mountedReport() {
      if (this.PVIformat) {
        this.reportAll(this.showArr.slice(0, 3))
      }
    },

    /**
       * 展开收起
       */
    spread() {
      this.isSpread = !this.isSpread
      if (this.isSpread && this.PVIformat && this.firstOpen) {
        // 第一次展开全部，上报从第3个起之后所有业务
        this.firstOpen = false
        if (this.PVIformat) {
          this.reportAll(this.showArr.slice(3))
        }
        if (this.clickIformat) {
          this.log(`${this.clickIformat}_unfold`)
        }
      }
    }
  }
})
